import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Grid, Button } from 'semantic-ui-react';
import ReactTable from 'react-table';

import {
  fetchApplicationHistory,
  fetchApplication,
} from './../state/applicationhistory/actions';
import { Filter, Main } from 'Containers';
import { errorToast } from 'Common/ToastHelper';
import * as objects from './../helpers/ApplicationHistoryObjects';
import { ActiveStatusEnum } from 'Common/Constants/Enumeration/ActiveStatusEnum';

import 'PageStyles/manageapplication/index.less';
import { defaultDateFormat } from 'Common/GeneralHelper';

class ApplicationHistory extends Component {
  static path = '/manageapplication/history/:familyId';

  state = {
    selectedFilter: objects.AppHistoryFilterEnum.All,
  };

  familyId = this.props.match.params.familyId;

  componentDidMount() {
    this.props.fetchApplicationHistory(this.familyId);
    this.props.fetchApplication(this.familyId);
  }

  componentDidUpdate(prevProps) {
    errorToast(this.props, prevProps, 'fetchError');
  }

  getRootUrl = () => {
    const { url } = this.props.match;
    let rootPath = url.substring(0, url.lastIndexOf('/history'));

    if (!this.props.appData || !this.props.appData.data) {
      return rootPath;
    }
    const { ActiveStatus } = this.props.appData.data.ApplicationInformation;

    if (ActiveStatus === ActiveStatusEnum.Archived) {
      rootPath = `${rootPath}/?r=archived`;
    } else if (ActiveStatus === ActiveStatusEnum.Deleted) {
      rootPath = `${rootPath}/?r=deleted`;
    }

    return rootPath;
  };

  handleFilterChange(e, value) {
    this.props.fetchApplicationHistory(this.familyId, value);
    this.setState({ selectedFilter: value });
  }

  getHoH() {
    if (this.props.appData.data && this.props.appData.data.Members) {
      const hoh = this.props.appData.data.Members.find(member => member.IsHOH);
      return `${hoh.LastName}, ${hoh.FirstName}`;
    }
    return '';
  }

  getAppDate() {
    if (
      this.props.appData.data &&
      this.props.appData.data.ApplicationInformation
    ) {
      return defaultDateFormat(
        this.props.appData.data.ApplicationInformation.ApplicationDate
      );
    }
    return '';
  }

  getMainProps = () => {
    return {
      toolbox: {
        backButtonProps: { shown: true, path: this.getRootUrl() },
        shown: true,
      },
    };
  };

  render() {
    const { fetching } = this.props;

    return (
      <Fragment>
        <Filter title={'Application History'} />
        <Main {...this.getMainProps()}>
          <Grid>
            <Grid.Row columns={3}>
              <Grid.Column>
                <label className="text-orange">Family #:</label>
                <span>{this.familyId}</span>
              </Grid.Column>
              <Grid.Column>
                <label className="text-orange">Head of Household:</label>
                <span>{this.getHoH()}</span>
              </Grid.Column>
              <Grid.Column>
                <label className="text-orange">Application Date:</label>
                <span>{this.getAppDate()}</span>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <label className="text-orange">Review changes in:</label>
                <Button.Group basic className={`btn-group--active-group`}>
                  {objects.options.map((option, i) => (
                    <Button
                      basic
                      active={this.state.selectedFilter === option.value}
                      className="white"
                      key={i}
                      onClick={e => this.handleFilterChange(e, option.value)}
                      disabled={fetching}
                    >
                      {option.label}
                    </Button>
                  ))}
                </Button.Group>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <ReactTable
                  columns={objects.columns}
                  data={this.props.historyData}
                  defaultPageSize={10}
                  minRows={10}
                  showPageSizeOptions={true}
                  pageSizeOptions={[10, 20, 25, 50, 100]}
                  loading={fetching}
                  defaultSorted={[
                    {
                      id: 'OccurenceDT',
                      desc: true,
                    },
                  ]}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    fetching: state.ManageApplicationState.applicationHistory.fetching,
    fetchError: state.ManageApplicationState.applicationHistory.fetchError,
    historyData: state.ManageApplicationState.applicationHistory.historyData,
    appData: state.ManageApplicationState.applicationHistory.appData,
  };
};

export const AppHistory = withRouter(
  connect(
    mapStateToProps,
    {
      fetchApplicationHistory,
      fetchApplication,
    }
  )(ApplicationHistory)
);



// WEBPACK FOOTER //
// ./src/pages/manageapplication/subpages/ApplicationHistory.js